// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function nigerianOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'ng',
    phone_number: userInputValues['nigerianPhoneNumber'],
    bank_details: {
      bank_code: userInputValues['selectedBankCode'],
      account_number: userInputValues['nigerianAccountNumber'] !== undefined ? userInputValues['nigerianAccountNumber'] : '',
    },
  };
}
